import { useMemo } from 'react';
import { Table } from '../../../../Components/uielements';
import { IconButton, TableCell } from '../../../../services/settings/appStyle/global.style';
import { DeleteIcon } from '../../../../Components/icons';
import { IntlMessages } from '../../../../helper/langHelper';

const AddProductTable = (props) => {
  const { data = [], onDelete } = props;
  console.log(data);
  const productTable = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.chemical" />,
        accessor: 'chemicalName',
      },
      {
        Header: <IntlMessages id="table.col.rate" />,
        accessor: 'rate',
      },
      {
        Header: <IntlMessages id="table.col.date" />,
        accessor: 'applicationDate',
        width: '20%',
        Cell: (cellData) => <TableCell color="primary">{cellData.value}</TableCell>,
      },
      {
        Header: <IntlMessages id="table.col.WHP/ESI/ESFI" />,
        accessor: 'WHP',
      },
      {
        Header: <IntlMessages id="table.col.action" />,
        accessor: 'action',
        isAction: true,
      },
    ],
    []
  );
  const actionList = [
    (data, index) => (
      <IconButton type="button" onClick={() => onDelete(data, index)}>
        <DeleteIcon style={{ width: '15px', height: '15px' }} />
      </IconButton>
    ),
  ];

  const AddProduct = () => {
    return (
      <Table
        data={data}
        name="prototypeListView"
        columns={productTable}
        hasFooter={false}
        actions={actionList}
        notRequireEmptyState={true}
      />
    );
  };

  return <> {AddProduct()}</>;
};

export default AddProductTable;
